export default __webpack_public_path__ + "static/media/download.569e9d64.svg";